export const DEFAULT_LOCALE = "en-US";
export const DEFAULT_LABEL = "English(US)";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";
export const FAQPAGE_MESSAGE_BUNDLE_NAME = "pages.faqpage";
export const POLICYPAGE_MESSAGE_BUNDLE_NAME = "pages.policypage";
export const PRODUCTPAGE_MESSAGE_BUNDLE_NAME = "pages.productpage";

export const LOCALE_VALUES = {
  EN_US: "en-US",
  EN_CA: "en-CA",
  ES_MX: "es-MX",
  FR_CA: "fr-CA",
};

export const LOCALES = [
  { langLable: "English(US)", langValue: LOCALE_VALUES.EN_US },
  { langLable: "English(CA)", langValue: LOCALE_VALUES.EN_CA },
  { langLable: "Español(MX)", langValue: LOCALE_VALUES.ES_MX },
  { langLable: "Français(CA)", langValue: LOCALE_VALUES.FR_CA },
];
